// GPH Expert Intelligence Core — Research Client.
// Chama POST /api/gph/research (auth Bearer, mesmo padrão das calculadoras).
// Qualquer falha vira resposta honesta {researched:false} — nunca trava a UX
// nem fabrica fontes. O resultado passa pelo Truth Policy antes do render.

import { auth } from '../../firebase';
import { API_URL } from '../../config';
import { sanitizeResearchAnswer } from './gphTruthPolicy';

const OFFLINE_ANSWER = {
  researched: false,
  providerStatus: 'unavailable',
  synthesis: null,
  sources: [],
  supportMaterial: null,
  overallConfidence: 0.5
};

export const requestResearch = async ({ game, intent, objective, weapon = '', queryType = 'web_and_video', userContext = '' }) => {
  try {
    const token = await auth.currentUser?.getIdToken();
    if (!token) return { ...OFFLINE_ANSWER };

    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 20000);

    const response = await fetch(`${API_URL}/gph/research`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify({
        game,
        intent,
        objective: String(objective || '').slice(0, 300),
        weapon: String(weapon || '').slice(0, 48),
        query_type: queryType,
        user_context: String(userContext || '').slice(0, 300)
      }),
      signal: controller.signal
    });
    clearTimeout(timer);

    if (!response.ok) return { ...OFFLINE_ANSWER };
    const data = await response.json().catch(() => null);
    return sanitizeResearchAnswer(data).sanitized;
  } catch {
    return { ...OFFLINE_ANSWER };
  }
};

export default requestResearch;
